<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :showOs="true",
      :showMunicipios="true",
      :configuracaoFiltro="configuracaoFiltro",
      :showFiltroTipoPagamentoCOF="true",
      :filtroRapido="filtroRapido",
      :isCOF="true",
      :showFiltroDae="true"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro",
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="initDAEVTN",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false"
  )
</template>

<script>
import moment from 'moment'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import { mapActions } from 'vuex'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto

  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      count: 0,
      filtro: FILTRO_EMPTY('GESTAO_VTN'),
      items: [],
      totalElements: 0,
      showModalVisualizarProcesso: false,
      numeroProcesso: null,
      protocolo: null,
      idProcesso: null,
      tipoProcesso: null,
      configuracaoFiltro: {
        filtroSituacaoBoleto: filtro?.filtroSituacaoBoleto?.DAE_VTN || [],
        filtroTipoPagamento: filtro?.filtroTipoPagamento?.DAE_VTN || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [] },
        { id: 4, titulo: 'Tipo de Pagamento', propriedade: 'vtnBoleto.formaPagamento', formatter: this.formatFormaPagamentoVtn, ordem: 4, acoes: [] },
        { id: 5, titulo: 'Vencimento', propriedade: 'vtnBoleto.dataVencimento', formatter: this.formatData, ordem: 5, acoes: [] },
        { id: 6, titulo: 'Situação', propriedade: 'vtnBoleto.situacao', formatter: this.formatSituacao, ordem: 6, acoes: [] },
        {
              id: 7, titulo: 'Ações', propriedade: 'tipo', ordem: 7, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 1, nome: 'Visualizar VTN', icone: 'fa-eye', codigo: 'VISUALIZAR_VTN', ordem: 2, show: this.shwowVisualizarVtn },
            { id: 1, nome: 'Gerenciar VTN', icone: 'fa-file-invoice-dollar', codigo: 'GERENCIAR', ordem: 3, show: this.showGerenciarVTN },
            { id: 1, nome: 'Emitir Certidão de Quitação', icone: 'fa-file-invoice-dollar', codigo: 'EMITIR_CERTIDAO', ordem: 4, show: this.showEmitirCertidao },
            { id: 1, nome: 'Visualizar Certidão de Quitação', icone: 'fa-eye', codigo: 'EMITIR_CERTIDAO', ordem: 4, show: this.showVisualizarCertidao }
          ]
        }
      ],
      filtroRapido: null
    }
  },

  async created () {
    this.initDAEVTN()
  },

  watch: {
    async '$route' (to, from) {
      this.initDAEVTN()
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  methods: {
    ...mapActions({
      setProcesso: 'processos/setProcesso',
      getUltimoBoletoByProcesso: 'dae/getUltimoBoletoByProcesso',
      existsByDocumentoOrigem: 'dae/existsByDocumentoOrigem'
    }),

    shwowVisualizarVtn (item) {
      if (item.vtn) {
        return true
      }
      return false
    },

    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    },
    VISUALIZAR_VTN: async (_this, { item }) => {
      _this.$store.commit('processos/SET_PROCESSO', item)
      _this.$router.push({
        name: 'calculoPagamento',
        params: {
          idVtn: item.vtn.id,
          showBotaoFinalizar: false
        }
      })
    },
    GERENCIAR: async (_this, { item }) => {
      _this.$router.push({
        name: 'VISUALIZAR_DAES_COF',
        params: {
          idProcesso: item.id
        }
      })
    },
    EMITIR_CERTIDAO: async (_this, { item }) => {
      _this.$router.push({
        name: 'EMITIR_CERTIDAO',
        params: {
          idProcesso: item.id,
          visualizarCertidao: item.certidaoQuitacaoEmitida
        }
      })
    },
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },

    formatFormaPagamentoVtn (item) {
      return item.vtnBoleto?.formaPagamento ? (item.vtnBoleto.formaPagamento === 'A_VISTA' ? 'À vista' : 'À prazo') : '-'
    },

    formatData (item) {
      if (!item.vtnBoleto?.dataVencimento) {
        return item.dataVencimentoDAE
      }
      return item.vtnBoleto?.dataVencimento ? moment(item.vtnBoleto.dataVencimento).format('DD/MM/YYYY') : '-'
    },

    formatSituacao (item) {
      if (!item.vtnBoleto) { return item.status }

      switch (item.vtnBoleto?.situacao) {
        case 'AGUARDANDO_PAGAMENTO':
          return 'Aguardando Pagamento'
        case 'AGUARDANDO_EMISSAO_BOLETO':
          return 'Aguardando Emissão de Boleto'
        case 'QUITADO':
          return 'Quitado'
        case 'VENCIDO':
          return 'Vencido'
      }
    },

    async existsBoleto (prop) {
      const exists = await this.existsByDocumentoOrigem({
        processo: prop.numeroProcesso
      })
      return exists
    },

    async getBoleto (prop) {
      const boleto = await this.getUltimoBoletoByProcesso({
        processo: prop.numeroProcesso
      })
      return boleto
    },

    async formatDataVencimento (prop) {
      try {
        if (await this.existsBoleto(prop)) {
          const boleto = await this.getUltimoBoleto(prop)
          return boleto.dataVencimento ? new Date(boleto.dataVencimento).toLocaleDateString('pt-BR') : '-'
        } else if (prop.dataVencimento) {
          return prop.dataVencimento
        } else {
          return '-'
        }
      } catch (error) {
        console.error('Erro na função getDataEmissaoSync:', error)
        return 'ERRO'
      }
    },

    showGerenciarVTN (prop) {
      if (this.count < 2) {
        this.count += 1
      }
      if (!prop.vtnBoleto) { return false }
      return true
    },

    showEmitirCertidao (item) {
      if (!item.vtnBoleto) { return false }
      if (item.vtnBoleto?.situacao === 'QUITADO' && !item.certidaoQuitacaoEmitida && item.tituloEmitido) {
        return true
      } else return false
    },

    showVisualizarCertidao (item) {
      if (!item.vtnBoleto) { return false }

      if (item.vtnBoleto?.situacao === 'QUITADO' && item.certidaoQuitacaoEmitida) {
        return true
      } else return false
    }
  }
}
</script>
    <style lang="scss" scoped>
    .card-container {
      margin: 20px;
      border-radius: 10px;
    }
    </style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaGestaoVtnListagem.vue